document.addEventListener("DOMContentLoaded", function () {
	function scrollToAnchor() {
        "use strict";
        var scrollFunction = function (href, event) {
            var target = document.querySelector(href);
            if (target) {
                event.preventDefault();
                var scrollDistance = document.querySelector('.header__wrapper').offsetHeight;
                var targetOffsetTop = target.offsetTop;
                var scrollOffset = targetOffsetTop - scrollDistance;
    
                // Płynne scrollowanie
                window.scrollTo({
                    top: scrollOffset,
                    behavior: 'smooth'
                });
            }
        };
    
        var elements = document.querySelectorAll(".scrollTo, .scrollTo a, a[href*='#']");
        elements.forEach(function (element) {
            element.addEventListener("click", function (e) {
                var href = element.getAttribute("href");
                scrollFunction(href, e);
            });
        });
    }
    
    scrollToAnchor();
});
